import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { InformacionDocumentacionEmpadronamiento } from "./InformacionDocumentacionEmpadronamiento";
import { getPatologiasEmp } from "../../../../actions/empadronamiento/Empadronamiento";
import { useDispatch, useSelector } from "react-redux";

export const DocumentacionMenu = ({ solicitud }) => {
  const dispatch = useDispatch();
  const { solicitudSeleccionada = {}, patologiasEmpadronamiento, idTipoEmpadronamiento } = useSelector(
    (state) => state.empadronamiento
  );
  const idPatologia = solicitudSeleccionada?.idPatologia ?? 0;

  useEffect(() => {
    dispatch(getPatologiasEmp(idTipoEmpadronamiento))
  }, [dispatch]);

  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Documentacion Programa
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="select-patologia-label">Patologia</InputLabel>
        <Select
          labelId="select-patologia-label"
          id="select-patologia"
          value={idPatologia}
          label="Patologia"
          disabled={true}
        >
          {patologiasEmpadronamiento.map((patologia) => (
            <MenuItem key={patologia.idPatologia} value={patologia.idPatologia}>
              {patologia.descripcion}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <InformacionDocumentacionEmpadronamiento
        disabled={true}
        setFaltaDocumentacion={false}
        idPatologia={idPatologia}
      />
    </React.Fragment>
  );
};
